import { render, staticRenderFns } from "./PosReceivables.vue?vue&type=template&id=779080c6"
import script from "./PosReceivables.vue?vue&type=script&lang=js"
export * from "./PosReceivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports